<template>
  <div>
    <!-- LABEL -->
    <div class="flex-end filter-wrap">
      <el-input
        class="filter-input"
        type="text"
        v-model="track"
        placeholder="Search track"
        clearable
      />
      <el-button class="btn-main" type="primary" @click="filter()">
        Filter
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      dev: process.env.VUE_APP_IN_DEVELOPMENT,
      dialog: false,
      artist: '',
      track: '',
      date_range: ''
    }
  },

  computed: {
    ...mapState('labelTracks', ['loading'])
  },

  methods: {
    ...mapActions('labelTracks', ['readMyTracks']),
    ...mapMutations('labelTracks', ['setPage', 'setPageSize']),

    filter() {
      this.setPage(1)
      let filter_data = {
        date_range: this.date_range,
        track_name: this.track
      }
      localStorage.setItem('label_track_filter', JSON.stringify(filter_data))
      this.readMyTracks(filter_data)
      this.filtersEmpty()
      this.dialog = false
    },

    filtersEmpty() {
      let ls = JSON.parse(localStorage.getItem('label_track_filter'))
      if (ls) {
        const { page, page_size, ...active_filters } = ls

        let f = Object.values(active_filters).filter(function(n) {
          return n > 0 || n != ''
        })

        if (f != null && f.length) return false
      }

      return true
    },

    submitMusic(){
      this.$router.push('/label/submit-music');
    }
  },

  created() {
    let ls = JSON.parse(localStorage.getItem('label_track_filter'))

    if (ls !== null && ls.date_range !== null) {
      this.date_range = ls.date_range
    }

    if (ls !== null && ls.track_name !== null) {
      this.track = ls.track_name
    }

    this.filtersEmpty()
  }
}
</script>
